<template>
  <div class="MajorSearchBackground">
    <div id="header">
      <div id="headerBtnContainer">
        <div style="display: flex;align-items: center">
          <div id="selectSearchContainer">
            <el-input style="width: 150px" :prefix-icon="Search" clearable  @clear="inputSearchButtonClick" v-model="majorName" placeholder="请输入院校名称"
                      @keyup.enter="inputSearchButtonClick"/>
          </div>
          <div id="inputSearchContainer">
            <el-input style="width: 150px" :prefix-icon="Search" clearable  @clear="inputSearchButtonClick" v-model="majorName" placeholder="请输入专业名称"
                      @keyup.enter="inputSearchButtonClick"/>
            <el-button id="inputSearchButton" style="margin-left: 15px"  @click="inputSearchButtonClick">搜索</el-button>
          </div>
        </div>
        <div style="display: flex;align-items: center">

        </div>
      </div>
      <div id="menuContainer">院校专业考研方向</div>
      <div id="headerTips">注：国标代码不可用于填报</div>

    </div>
    <div id="mainBody">
      <el-scrollbar ref="mainBodyScrollbar">
        <div id="IncludingColleges">
          <div class="collegesContainer" v-for="item in mainArray">
            <div class="collegesLine1">
<!--              <span @click="goMajorSituation(item.majorCode)"></span>-->

              <el-row align="bottom" style="height:100%;display:flex;align-items: center;" >
                <el-col :span="8">{{item.collegeName}}</el-col>
                <el-col :span="8">{{item.majorName}}</el-col>
<!--                <el-col :span="8">国标代码：{{item.majorCode}}</el-col>-->
              </el-row>

            </div>
            <div class="collegesLine2">
              <el-row style="height:100%;display:flex;align-items: center">
                <el-col :span="8">内部编码：{{item.collegeCode}}</el-col>
                <el-col :span="8">国标代码：{{item.majorCode}}</el-col>
                <el-col :span="8"><el-button id="viewBtn" type="primary">查看</el-button></el-col>
              </el-row>
            </div>
          </div>
          <el-empty style="margin-top: 100px" v-if="mainArray.length == 0" description="暂无数据" />
        </div>
      </el-scrollbar>

    </div>
  </div>
</template>

<script setup>
  import {ref, reactive, nextTick} from 'vue'
  import {ElMessage} from 'element-plus';
  import {Search} from '@element-plus/icons-vue'
  import {useRouter, useRoute} from "vue-router";
  import {majorsFindMajorByName} from "@/network/axios";

  let router = useRouter();
  let route = useRoute();

  //检查 机型
  let _isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
  };
  //如果是手机 就跳转手机页面
  if (_isMobile()) {
    router.push('/MobileMajorSearch')
  }

  let goFirstPage = () => {
    window.open('/', '_blank')
  }


  let mainArray =ref([
    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'经济学',
      majorCode:'020101',
    },
    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'经济统计学',
      majorCode:'020102',
    },
    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'国民经济管理',
      majorCode:'020103T',
    },

    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'资源与环境经济学',
      majorCode:'020104T',
    },
    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'商务经济学',
      majorCode:'020105T',
    },
    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'能源经济',
      majorCode:'020106T',
    },
    {
      collegeName:'阿坝师范学院',
      collegeCode:'1',
      majorName:'劳动经济学',
      majorCode:'020107T',
    },


  ]);
  let level =ref(1);
  let majorName =ref('');
  // let searchMajor =()=>{
  //   majorsFindMajorByName('/majors/findMajorByName',{
  //     params:{
  //       leave:level.value,
  //       majorName:majorName.value,
  //     }
  //   }).then((res)=>{
  //     if (res.data.code == 200){
  //       mainArray.value=[];
  //       mainArray.value=res.data.data;
  //     }
  //   })
  // }
  // searchMajor();


  let selectChange =()=>{
    searchMajor()
  };

  let inputSearchButtonClick =()=>{
    searchMajor()
  };

  let goMajorSituation =(majorCode)=>{
    window.open('/MajorSituation' + '/' + majorCode, '_blank')
  }

</script>

<style scoped>
  .MajorSearchBackground {
    position: relative;
    width: 100%;
    height: 100%;
    /*background: #bfa;*/
    display: flex;
    justify-content: left;
    flex-direction: column;
    align-items: center;
    /*overflow: auto;*/
  }

  #header {
    min-width: 850px;
    min-height: 130px;
    width: 1004px;
    height: 19%;
    /*background: #bfa;*/
    position: relative;
    border: 2px solid #ededed;
    border-bottom: 1px solid #cd3532;
    border-top: none;
    /*display: flex;*/
    /*align-items: center;*/
    /*flex-direction: column;*/
    /*justify-content: space-around;*/
    padding: 0 18px;
  }

  #headerBtnContainer {
    width: 100%;
    height: calc(100% - 25px);
    display: flex;
    /*flex-direction: column;*/
    justify-content: space-between;
    /*background: #bfa;*/
  }

  /*头部左半部分搜索的 大容器*/
  #inputSearchContainer {
    display: flex;
    /*justify-content: space-between;*/
    /*width: 100%;*/
    /*align-items: center;*/
  }

  #inputSearchContainer div {
    display: flex;
  }


  #inputSearchButton,#viewBtn {
    /*margin-left: 15px;*/
    width: 70px;
    letter-spacing: 7px;
    text-indent: 7px;
    color: white;
    border: none;
  }

  >>> #inputSearchButton,#viewBtn {
    --el-button-bg-color: #ce3432;
    --el-button-hover-bg-color: #F56C6C;
  }

  #inputSearchContainer >>> .el-input {
    --el-input-focus-border-color: #F56C6C;
  }

  /*头部右半部分搜索 的大容器*/
  #selectSearchContainer {
    display: flex;
    /*width: 350px;*/
    /*margin-bottom: 25px;*/
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-right: 15px;
  }



  .selectContainer {
    margin-right: 15px;
  }

  .elPopperSelect .el-select-dropdown__item.selected {
    color: #F56C6C;
  }

  #selectSearchButton {
    /*width: 70px;*/
    /*letter-spacing: 7px;*/
    /*text-indent: 7px;*/
    /*color: white;*/
    /*border: none;*/
  }

  #selectSearchContainer >>> .el-select {
    --el-select-input-focus-border-color: #F56C6C;
  }

  /*#selectSearchContainer >>> .el-button {*/
  /*  --el-button-bg-color: #ce3432;*/
  /*  --el-button-hover-bg-color: #F56C6C;*/
  /*}*/

  .elPopperSelect >>> .el-select-dropdown__item.selected {
    color: #F56C6C;
  }

  /* 院校查询 标题栏 */
  #menuContainer {
    position: absolute;
    left: 18px;
    bottom: 0;
    padding: 3px 25px 3px 7px;
    background: #cd3532;
    color: white;
    font-size: 18px;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    clip-path: polygon(0% 0%, 85% 0%, 100% 100%, 0% 100%);
  }

  /*提示*/
  #headerTips {
    position: absolute;
    left: 200px;
    bottom: 5px;
    color: #606266;
    font-size: 15px;
  }

  /* 右方 跳转按钮 容器*/
  #majorsInquireBtnContainer {
    position: absolute;
    height: 100%;
    width: 170px;
    /*background: #bfa;*/
    display: flex;
    align-items: center;
    justify-content: right;
    right: -170px;
  }

  #majorsInquireBtn {
    /*color: white;*/
    /*border: none;*/
    /*--el-button-bg-color: #cd3532;*/
    /*--el-button-hover-bg-color: #F56C6C;*/
    /*margin-bottom: 25px;*/
  }


  /*body 栏*/
  #mainBody {
    width: 1004px;
    height: 81%;
    border: 2px solid #ededed;
    border-top: none;
    /*background: #bfa;*/
  }


  #IncludingColleges {
    width: 100%;
    /*height: 100%;*/
    /*background: #bfa;*/
    padding: 0 18px;
    /*border-right: 2px solid #ededed;*/
  }

  .collegesContainer {
    width: 100%;
    height: 75px;
    border-bottom: 1px solid #d4d8e1;
    /*background: yellow;*/
  }

  .collegesLine1 {
    width: 100%;
    height: 50%;
    /*vertical-align: bottom;*/
    /*background: #bfa;*/
    /*display: flex;*/
    /*align-items: end;*/
  }

  .collegesLine1 span {
    cursor: pointer;
  }

  .collegesLine1 span:hover {
    color: #F56C6C;
  }

  .collegesLine2 {
    width: 100%;
    height: 50%;
    /*background: orange;*/
    /*display: flex;*/
    /*align-items: center;*/
    font-size: 14px;
    color: #606266;
  }

  @media screen and (min-width: 2000px) {
    #header {
      height: 15%;
    }

    #mainBody {
      height: 85%;
    }
  }


  @media screen and (min-width: 2250px) {
    #header {
      height: 13%;
    }

    #mainBody {
      height: 87%;
    }
  }
</style>
